import { useSelector } from 'react-redux'

import { VisibleLogCategory } from './slice'
import {
  chatIntroDialogIdSelector,
  isTryDockRunningSelector,
  visibleLogCategoriesSelector
} from './selectors'

export function useIsTryDockRunning(): boolean | undefined {
  return useSelector(isTryDockRunningSelector)
}

export function useChatIntroDialogId(): string | undefined {
  return useSelector(chatIntroDialogIdSelector)
}

export function useVisibleLogCategories(): VisibleLogCategory[] {
  return useSelector(visibleLogCategoriesSelector)
}
